<!--
  Компонент для отрисовки формы правки или представления данных по одной строке из любой таблицы. 
  Получает данные из любых Страницы или Таблицы и показывает вьюс или форму правки.
-->
<template>
  <!-- <v-btn @click="mode = 'edit'">e</v-btn> -->
  <template v-if="mode === 'edit'">

       <!-- <classify-widget v-bind="{mode:mode,column:column}" v-model="value" ></classify-widget>  -->
       <!-- <classify-widget v-bind="{mode:'edit',column:'v.currentstorage', lengthrow:lengthrow}" ></classify-widget>  -->
<!-- {{ meta }} -->
 
    <v-sheet v-for="col in meta.columns" :key="col"> 
      {{ col.fieldname }}
    </v-sheet>
    <!-- <v-sheet v-for="col in meta.columns" :key="col">
 <base-geo-cell v-bind="{mode:'edit', column:col, initValue:col.fieldname, meta:meta, rowobject:value}" 
 v-model="edited[col.fieldname]"/>
      </v-sheet> -->

        <!-- <v-sheet class="d-flex flex-wrap my-lg-2 px-1">
            <v-sheet class="my-1 mr-4">
            <span class="text-h5">LID</span><span class="text-h5 font-weight-bold">{{v.linkid}}</span>
            </v-sheet>
          <div class="d-none d-sm-none d-md-flex">
            <v-sheet class="my-1 mr-4">
              <span class="text-h5">{{ v.currentstorage.name }} <v-tooltip activator="parent" location="bottom">Current storage</v-tooltip></span>
            </v-sheet>
          </div>
            <v-sheet class="my-1 mr-4 flex-nowrap">
            <span class="text-h5"> {{ v.mainstorage.name }}<v-tooltip activator="parent" location="bottom">Main storage</v-tooltip></span> 
              <span class="text-h5 font-weight-bold"> {{ v.localcollnumber }} <v-tooltip activator="parent" location="bottom">Local collection number</v-tooltip></span>
            </v-sheet>

        </v-sheet>




        <div class="d-none d-sm-none d-md-flex my-1 my-lg-2 px-1">
            <span class="text-h3 font-weight-black text-truncate" style="max-width: 1500px;">{{ v.store }} <v-tooltip activator="parent" location="end">Store species</v-tooltip></span>
        </div> -->

  </template>    

  <template v-if="mode === 'view'">

<!-- BGC: {{ meta }} -->
<!-- <base-geo-cell 
v-if="meta.column.fieldname == 'coordinates'"
  v-bind="{mode:'view', column:column, initValue:value[column.fieldname], meta:meta, rowobject:value}" 
  v-model="value[column.fieldname]"
/> -->





    <div class="px-lg-3">
      <!-- <div v-if="$store.state.isAdmin" class="my-1 px-1"><base-table-page-tools></base-table-page-tools></div> -->
        <v-sheet class="d-flex flex-wrap my-lg-2 px-1">
            <v-sheet class="my-1 mr-4">
            <span class="text-h5">LID</span><span class="text-h5 font-weight-bold">{{v.linkid}}</span>
            </v-sheet>
          <div class="d-none d-sm-none d-md-flex">
            <v-sheet class="my-1 mr-4">
              <span class="text-h5">{{ v.currentstorage.name }} <v-tooltip activator="parent" location="bottom">Current storage</v-tooltip></span>
            </v-sheet>
          </div>
            <v-sheet class="my-1 mr-4 flex-nowrap">
            <span class="text-h5"> {{ v.mainstorage.name }}<v-tooltip activator="parent" location="bottom">Main storage</v-tooltip></span> 
              <span class="text-h5 font-weight-bold"> {{ v.localcollnumber }} <v-tooltip activator="parent" location="bottom">Local collection number</v-tooltip></span>
            </v-sheet>

        </v-sheet>

              <!--px-2 - make padding -->
              <!--три блока - бюрократия, география, таксономия--> 


        <div class="d-none d-sm-none d-md-flex my-1 my-lg-2 px-1">
            <span class="text-h3 font-weight-black text-truncate" style="max-width: 1500px;">{{ v.store }} <v-tooltip activator="parent" location="end">Store species</v-tooltip></span>
        </div>
    </div>
<div v-if="v.species.rows!=''"> 
        <div v-for="rowsp in v.species.rows" v-bind:key="rowsp">
          <div class="px-lg-4 px-1 text-h5 text-truncate"> {{ rowsp.species.name }} </div>
          <div class="d-none d-sm-none d-md-flex ml-3">
          <div class="ml-1 mr-2"><image-widget v-if="rowsp.picturesp" v-bind="{mode:'view',column:meta}" v-model="rowsp.picturesp" /></div>
          </div>
          <div class="d-lg-none d-md-none d-xl-flex "><!--mobile-->
          <div class="ml-1 mr-2"><image-widget v-if="rowsp.picturesp" v-bind="{mode:'view',column:meta}" v-model="rowsp.picturesp" /></div>
          </div>
          <v-divider class="ma-2"></v-divider>
        </div>
        <div class="px-lg-3">
          <div class="text-h5 px-1 d-flex flex-wrap">
            Det: &nbsp<date-widget v-bind="{mode:'view',column:column}" v-model="v.species.rows[0].detdate" />&nbsp  {{ v.species.rows[0].detname2 }}&nbsp
            <v-btn
              class="mr-1"
              variant="outlined"
              color="regular"
              @click="speciesDetails = true">
              <svg-icon type="mdi" :path="mdiArrowExpand"/> Species in details
            </v-btn>
          </div>
        </div>
</div>
<div v-else>
  <div class="px-lg-3">
    <div class="text-h5 px-1">
      <v-btn
        class="mr-1 my-1"
        variant="outlined"
        color="regular"
        @click="$router.push('/help')">
        <svg-icon type="mdi" :path="mdiHelp"/> No species (click to help)
      </v-btn>
    </div>
  </div>  
</div>

<div class="d-none d-sm-none d-md-flex">
           <v-btn
                        v-if="v.coordinates"
                        variant="text"
                        color=""
                        v-copy="v.coordinates"
                        @click="clicktooltipMessage"
                        >
                        <span class="text-h5">
                          <point-widget v-bind="{mode:'view',column:column}" v-model="v.coordinates" /> 
                        </span>
                        <v-tooltip
                          activator="parent"
                          location="bottom"
                        >Coordinates. {{clicktooltip}}</v-tooltip>
                      </v-btn>

                      <v-btn
                      v-if="v.legdate"
                        variant="text"
                        color="">
                        <span class="text-h5"><date-widget v-bind="{mode:'view',column:column}" v-model="v.legdate" /></span>
                        <v-tooltip
                          activator="parent"
                          location="bottom"
                        >Leg. Date</v-tooltip>
                      </v-btn>
                      <v-btn
                      v-if="v.legname2"
                        variant="text"
                        color="">
      <span class="text-h5">{{v.legname2}}</span>
                        <v-tooltip
                          activator="parent"
                          location="bottom"
                        >Leg. Name</v-tooltip>
                      </v-btn>
                      <v-btn
                      v-if="v.legnum"
                        variant="text"
                        color="">
                        <span class="text-h5"> {{v.legnum}}</span>
                        <v-tooltip
                          activator="parent"
                          location="bottom"
                        >Leg. number</v-tooltip>
                      </v-btn>

                      <v-btn
                      v-if="v.location"
                        @click="overlaylocation = !overlaylocation"
                        variant="text"
                        color="">
                        <span class="text-h5 text-truncate" style="max-width: 400px;">{{ v.location }}</span>
                        <v-tooltip
                          activator="parent"
                          location="bottom"
                        >Location. Click for more</v-tooltip>
                      </v-btn>
                      <v-overlay
                        v-model="overlaylocation"
                        class="align-center justify-center"
                        scroll-strategy="block"
                        max-width="800"
                      >
                      <card>
                      <v-card-title class="bg-white text-h4">Location</v-card-title><v-card-text class="bg-white text-h5">{{ v.location }}</v-card-text> 
                      </card>
                      </v-overlay>
                    
          <v-btn
                    class="mx-1 mb-1"
                        variant="outlined"
                        color="regular"
                        @click="geoEco = true">
                        <svg-icon type="mdi" :path="mdiArrowExpand"/> Geo-Eco-data
                      </v-btn>
</div>

                      <div class="d-sm-flex d-md-none">
                        <v-btn
          class="mx-1 my-1"
                        variant="outlined"
                        color="regular"
                        @click="geoEco = true">
                        <svg-icon type="mdi" :path="mdiArrowExpand"/> Geo-Eco-data
                      </v-btn>
                      </div>

<!--desktop-->
<map-point-widget-ol v-bind="{mode:'view',column:column, mapheight:mapheightpage}" v-model="v.coordinates" class="d-none d-sm-none d-md-flex rounded-0 px-4 mb-1">
</map-point-widget-ol>
<!--mobile-->
<map-point-widget-ol v-bind="{mode:'view',column:column, mapheight:mapheightpage}" v-model="v.coordinates" class="d-flex d-sm-none d-none d-sm-flex d-md-none mb-1">
</map-point-widget-ol>
<div class="px-lg-4">
<image-widget v-if="v.specimen_picture" v-bind="{mode:'view',column:meta}" v-model="v.specimen_picture" class="mb-1" />
</div>
<v-expansion-panels class="d-none d-sm-none d-md-flex">
    <v-expansion-panel
      class="px-4 pt-1"
      rounded="0"
    >
    <v-expansion-panel-title 
      @click="getExpansionTitle()"
      color="regularlight"
    >
      {{ expansiontitle }}
    </v-expansion-panel-title>
      <v-expansion-panel-text class="mx-n7">
        <v-sheet class="d-flex flex-wrap">
          <v-sheet
            v-for="col in meta.columns"
            :key="col"
          >
            <v-card
              v-if= "value[col.fieldname]"
              :title= col.title
              variant= outlined
              class="mx-1 my-1"
            > 
              <v-card-text>
                <base-geo-cell v-bind="{mode:'view', column:col, meta:meta, rowobject:value}" v-model="value[col.fieldname]" /> 
              </v-card-text>
            </v-card>

            <v-card
              v-if= "value[col.fieldname]==undefined"
              :title= col.title
              variant= flat
              color="vs"
              class="mx-1 my-1"
            > 
              <v-card-text>
                <p> &nbsp; </p>
              </v-card-text>
            </v-card>
          </v-sheet>
        </v-sheet>
      </v-expansion-panel-text>
    </v-expansion-panel>
  </v-expansion-panels>



 <v-dialog v-model="geoEco" fullscreen>
            <v-card class="rounded-0">

                    <div class="bg-white">
                      <v-card-title> <point-widget v-bind="{mode:'view',column:column}" v-model="v.coordinates" /> </v-card-title>
                      <v-card-text> <p>{{ v.location }} </p>
                      <p>Leg.: <date-widget v-bind="{mode:'view',column:column}" v-model="v.legdate" /> {{v.legname2}} {{v.legnum}}</p> </v-card-text>
                    </div>
<map-point-widget-ol v-bind="{mode:'view',column:column, mapheight:mapheightfull}" v-model="v.coordinates" >
</map-point-widget-ol>

     <div class="px-2">
              <v-card-actions>
                <v-row justify="space-between" class="text-center">
                  <v-col cols="auto"><v-btn
                    class="my-1"
                    variant="flat" 
                    color="regular" 
                    block @click="geoEco = false"
                  >Close</v-btn></v-col>
                </v-row>
              </v-card-actions>
      </div>
            </v-card>
          </v-dialog>


<v-dialog v-model="speciesDetails" fullscreen><!-- all data of speciesDetails-->
            <v-card class="overflow-auto rounded-0">
                    <div class="bg-white">
                      <!--v-card-title> И вот здесь вот показать всю детайлсину </v-card-title-->
                      <v-card-text>

                        <details-widget v-if="metadetails.widget" v-bind="{mode:'view', column:metadetails}" v-model="v.species" ></details-widget>
                      
                      </v-card-text>
                    </div>

      <div class="px-2">
              <v-card-actions>
                <v-row class="text-center">
                  <v-col cols="auto"><v-btn
                    class="my-1"
                    variant="flat" 
                    color="regular" 
                    block @click="speciesDetails = false"
                  >Close</v-btn></v-col>
                </v-row>

              </v-card-actions>
      </div>
            </v-card>
          </v-dialog>
  </template>

  <template v-else>
      {{v}}
  </template>
  
</template>

<script>
import ClassifyWidget from '@/components/widgets/ClassifyWidget.vue';
import DetailsWidget from '@/components/widgets/DetailsWidget.vue';
import PointWidget from '@/components/widgets/PointWidget.vue';
import ImageWidget from '@/components/widgets/ImageWidget.vue';
import BaseTablePageTools from '@/components/BaseTablePageTools.vue';
import DateWidget from '@/components/widgets/DateWidget.vue';
//import { LMap, LMarker, LTileLayer, LGeoJson, LControl } from "@vue-leaflet/vue-leaflet";
import MapPointWidgetOl from '@/components/widgets/MapPointWidgetOl.vue';
import BaseGeoCell from '@/components/BaseGeoCell.vue';
import SvgIcon from '@jamescoyle/vue-icon';
import { mdiArrowExpand, mdiHelp } from '@mdi/js';

export default {
    name: 'StandardDataMaterial',
    props:['mode','meta', 'value'],
    emits: ['update:modelValue'],
    data(){ 
        return {
            v: this.value,
            speciesDetails: false,
            geoEco: false,
            overlaylocation: false,
            metadetails: {},
         //   attribbutionmap: '<a target="_blank" href="http://osm.org/copyright">OpenStreetMap</a>',
         mapheightpage: "height: 200px",
         mapheightfull: "height: 50%",
         expansiontitle: "Expand all data",
         mdiArrowExpand:mdiArrowExpand,
         mdiHelp:mdiHelp,
        }
    }, 
    
    components: {
      SvgIcon,
DetailsWidget,
PointWidget,
//MapPointWidget,
ImageWidget,
BaseTablePageTools,
DateWidget,
MapPointWidgetOl,
/*LMap,

    LMarker,
    LTileLayer,
    LGeoJson,
    LControl,*/
    ClassifyWidget,
    BaseGeoCell,

    },

    mounted(){
      for (const column of this.meta.columns) {
        if(column.fieldname=='species'){
        this.metadetails=column;
//        console.log(column);
      break;
          }
        }
    },
    //и здесь

    methods:{
      
        handleInput (e) {            
           this.v = e.target.value;            
           this.$emit('update:modelValue', this.v)
        },
        getExpansionTitle() {
          if (this.expansiontitle == "Expand all data") {
            this.expansiontitle = "Hide all data";
          }
          else {
            this.expansiontitle = "Expand all data";
          }
        },

/*
formatDate(v) {
            const date = new Date(v);
                // Then specify how you want your dates to be formatted
            return new Intl.DateTimeFormat('ru-RU', {dateStyle: 'short'}).format(date);
        }
*/



    },




}
</script>